const initialState = {
  list: [],
  info: { users: [] },
  bio: {
    album: [],
    images: [],
    videos: [],
    music: [],
    documnet: [],
    link: [],
  },
};
export default function chat(state = initialState, action) {
  let { type, data } = action;
  switch (type) {
    case 'chat/list':
      return { ...state, list: data };
    case 'chat/info':
      return { ...state, info: data };
    case 'chat/bio':
      return { ...state, bio: data };
    default:
      return state;
  }
}
